"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import Link from "next/link";
import { cicToType } from "@/helpers/Helpers";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WaveDropAuthorPfp from "@/components/waves/drops/WaveDropAuthorPfp";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { ArtistSubmissionBadge } from "@/components/waves/drops/ArtistSubmissionBadge";
import { ArtistPreviewModal } from "@/components/waves/drops/ArtistPreviewModal";
interface MemesLeaderboardDropArtistInfoProps {
  readonly drop: ExtendedDrop;
}
const MemesLeaderboardDropArtistInfo: React.FC<MemesLeaderboardDropArtistInfoProps> = t0 => {
  const $ = _c(35);
  const {
    drop
  } = t0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const submissionCount = drop.author.active_main_stage_submission_ids?.length || 0;
  const hasSubmissions = submissionCount > 0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsModalOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleSubmissionBadgeClick = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsModalOpen(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleModalClose = t2;
  let t3;
  if ($[2] !== drop) {
    t3 = <WaveDropAuthorPfp drop={drop} />;
    $[2] = drop;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== drop.author.cic || $[5] !== drop.author.level) {
    t4 = drop.author?.level && <UserCICAndLevel level={drop.author.level} cicType={cicToType(drop.author.cic)} size={UserCICAndLevelSize.SMALL} />;
    $[4] = drop.author.cic;
    $[5] = drop.author.level;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== drop.author.handle || $[8] !== drop.author.id) {
    t5 = drop.author?.handle ? <UserProfileTooltipWrapper user={drop.author.handle ?? drop.author.id}><Link href={`/${drop.author?.handle}`} onClick={_temp} className="tw-no-underline desktop-hover:hover:tw-underline"><span className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold">{drop.author?.handle}</span></Link></UserProfileTooltipWrapper> : <Link href={`/${drop.author?.handle}`} onClick={_temp2} className="tw-no-underline desktop-hover:hover:tw-underline"><span className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold">{drop.author?.handle}</span></Link>;
    $[7] = drop.author.handle;
    $[8] = drop.author.id;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== drop.id || $[11] !== hasSubmissions || $[12] !== submissionCount) {
    t6 = hasSubmissions && <ArtistSubmissionBadge submissionCount={submissionCount} onBadgeClick={handleSubmissionBadgeClick} tooltipId={`leaderboard-badge-${drop.id}`} />;
    $[10] = drop.id;
    $[11] = hasSubmissions;
    $[12] = submissionCount;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="tw-size-[3px] tw-bg-iron-600 tw-rounded-full tw-flex-shrink-0" />;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== drop.created_at) {
    t8 = <WaveDropTime timestamp={drop.created_at} />;
    $[15] = drop.created_at;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t8) {
    t9 = <div className="tw-flex tw-items-center tw-gap-x-2">{t4}{t5}{t6}{t7}{t8}</div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const t10 = drop.winning_context?.decision_time || null;
  let t11;
  if ($[22] !== drop.rank || $[23] !== t10) {
    t11 = <WinnerDropBadge rank={drop.rank} decisionTime={t10} />;
    $[22] = drop.rank;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t9) {
    t12 = <div className="tw-flex tw-items-center tw-gap-x-3">{t9}{t11}</div>;
    $[25] = t11;
    $[26] = t9;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== drop.author || $[29] !== isModalOpen) {
    t13 = <ArtistPreviewModal isOpen={isModalOpen} onClose={handleModalClose} user={drop.author} />;
    $[28] = drop.author;
    $[29] = isModalOpen;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t12 || $[32] !== t13 || $[33] !== t3) {
    t14 = <div className="tw-flex tw-items-center tw-gap-x-3">{t3}{t12}{t13}</div>;
    $[31] = t12;
    $[32] = t13;
    $[33] = t3;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  return t14;
};
export default MemesLeaderboardDropArtistInfo;
function _temp(e) {
  return e.stopPropagation();
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}